import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { PageHeader } from "../components/site/PageHeader";
import { Reveal, Eyebrow } from "../components/site/Motion";
import { Marquee } from "../components/site/Marquee";

const VALUES = [
  { n: "01", t: "Stagionalità", d: "Lavoro con quello che la stagione offre: i fiori più belli sono quelli giusti nel momento giusto." },
  { n: "02", t: "Mano artigiana", d: "Ogni bouquet e ogni allestimento è composto a mano, pensato e costruito su misura." },
  { n: "03", t: "Ascolto", d: "Prima dei fiori vengono le persone: gusti, emozioni e il racconto che volete fare." },
];

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <main data-testid="about-page" className="bg-cream">
      <PageHeader testid="about-header" eyebrow="Chi sono" lines={["Sono Annette,", "floral designer"]}
        intro="Ho un negozio di fiori in Puglia e una passione che mi porta fuori dal bancone: disegnare i fiori dei matrimoni." />
      <section ref={ref} className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pb-24 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] rounded-t-[999px] overflow-hidden">
            <motion.img style={{ y, scale: 1.15 }} src="/img/about-annette.jpg" alt="Annette al lavoro al flower bar" className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-8 -right-2 sm:right-6 w-36 sm:w-48 aspect-square rounded-full bg-cream p-2 border border-stone/60 shadow-[0_20px_50px_rgba(44,64,46,0.15)]">
            <img src="/img/mark-a.png" alt="Logo Annette" className="w-full h-full object-cover rounded-full" />
          </div>
        </div>
        <div className="lg:col-span-6 lg:pt-16">
          <Eyebrow>La mia storia</Eyebrow>
          <Reveal>
            <p className="mt-6 font-serif text-3xl sm:text-4xl leading-[1.2] text-ink">
              I fiori sono il mio modo di raccontare le persone. In negozio li trasformo in gesti quotidiani; nei matrimoni, in <em className="text-terra">scenografie</em> che restano nella memoria.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base sm:text-lg text-ink/75 leading-relaxed">
              Dai colori accesi alle palette più delicate, dal boho di campagna alle linee più moderne: ogni progetto nasce da un incontro e cresce insieme a voi, dalla prima idea all'ultimo petalo.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <Link to="/contatti" data-testid="about-contact-cta" className="mt-10 inline-flex rounded-full bg-cypress text-cream px-6 py-3 text-sm hover:bg-terra transition-colors">Conosciamoci</Link>
          </Reveal>
        </div>
      </section>
      <Marquee />
      <section className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 sm:py-32 grid md:grid-cols-3 gap-px bg-stone">
        {VALUES.map((v, i) => (
          <Reveal key={v.n} delay={i * 0.1} className="bg-cream p-8 sm:p-10">
            <span className="font-serif italic text-6xl text-terra/80">{v.n}</span>
            <h3 className="mt-6 font-serif text-3xl text-ink">{v.t}</h3>
            <p className="mt-3 text-ink/75 leading-relaxed">{v.d}</p>
          </Reveal>
        ))}
      </section>
    </main>
  );
}
